class PaymentService {

  /*@ngInject*/
  constructor($resource, $window, cartService, parameterService) {
    this.$resource = $resource;
    this.$window = $window;
    this.cartService = cartService;
    this.parameterService = parameterService;
  }

  paymentResultModel(){
    return this.paymentResultModel;
  }

  setPaymentResultModel(value) {
    this.paymentResultModel = value;
  }

  buildPaymentRequest(checkoutModel, costs) {
    var cart = this.cartService.getCart();

    return {
      cart: {
        products: cart ? JSON.parse(cart) : []
      },
      fulfillment: {
        method: checkoutModel.fulfillment.method,
        deliveryDetails: checkoutModel.fulfillment.deliveryDetails,
        pickupBranchCode: checkoutModel.fulfillment.pickupDetails.branchNumber
      },
      orderByDetails: checkoutModel.orderByDetails,
      paymentType: costs.paymentType,
      paymentAmount: costs.totalInclGst,
      orderId: checkoutModel.orderId
    };
  }

  buildAcknowledgeRequest() {

    //  CC payload
    return {
      receiptNumber: this.parameterService.getParam('receiptNumber'),
      hmac: this.parameterService.getParam('hmac'),
      sessionId: this.parameterService.getParam('customSessionId'),
      paymentId: this.parameterService.getParam('paymentReference'),
      customerNumber : this.parameterService.getParam('customerReferenceNumber'),
      paymentAmount: this.parameterService.getParam('paymentAmount'),
      paymentDateTime: decodeURIComponent(this.parameterService.getParam('createdDateTime').replace(/\+/g, '%20')),
      settlementDate: this.parameterService.getParam('settlementDate'),
      responseCode: this.parameterService.getParam('responseCode'),
      summaryCode: this.parameterService.getParam('summaryCode'),
      cardScheme: this.parameterService.getParam('cardScheme'),
      maskedCardNumber: this.parameterService.getParam('maskedCardNumber'),
      cardholderName: decodeURIComponent(this.parameterService.getParam('cardholderName').replace(/\+/g, '%20')),
      expiryDateYear: this.parameterService.getParam('expiryDateYear'),
      expiryDateMonth: this.parameterService.getParam('expiryDateMonth'),
    };
  }

  buildPaymentDetailRequest(paymentDetailsModel) {
    return {
      details: paymentDetailsModel.threeDSResult,
    };
  }

  receivePaymentConfig() {
    var config = this.$resource('/bathrooms/cart/public/service/config', {}, {
      paymentConfig: {
        method: 'GET'
      }
    });

    return config.paymentConfig().$promise.then(
        function(response) {
         return {
           paymentKeys: {
             environment: response.environment,
             clientKey: response.clientKey
           }
         }
        }
    );
  }

  createRetailOrder(checkoutModel, costs) {
    var request = this.buildPaymentRequest(checkoutModel, costs);

    var RetailOrder = this.$resource('/bathrooms/cart/public/service/orders', {}, {
      'createOrder': {
        method: 'POST',
        headers: {'origin_company_id': this.$window.companyIdentifier}
      }
    });

    return RetailOrder.createOrder(request).$promise;
  }

  retrievePaymentDetails(paymentId, paymentDetailsModel) {
    var request = this.buildPaymentDetailRequest(paymentDetailsModel);
    var PaymentDetail = this.$resource('/bathrooms/cart/public/service/payment-detail/:paymentId', {paymentId: '@paymentId'}, {
      'retrievePaymentDetail': {
        method: 'POST',
        headers: {'origin_company_id': this.$window.companyIdentifier}
      }
    });

    return PaymentDetail.retrievePaymentDetail(request).$promise;
  }

  acknowledgePayment(orderId) {
    var AcknowledgePayment = this.$resource('/bathrooms/cart/public/service/payment/:paymentId/acknowledgement', {paymentId: '@paymentId'}, {
      post: {
        method: 'POST',
        headers: {'origin_company_id': this.$window.companyIdentifier}
      }
    });

    var payload= this.buildAcknowledgeRequest(orderId);

    return AcknowledgePayment.post(payload).$promise;
  }
}

export default PaymentService;






// WEBPACK FOOTER //
// ./src/app/services/payment-service.js